import { Divider } from '@heroui/react';
import { CartProduct, CartProductProps } from '@ui/cart/cart-product.tsx';
import { CartListStatus } from '@ui/cart/cart-list-status.tsx';

export const CartList = ({
  items = [],
  isDivided = false,
  isCompact = false,
  isShowPlaceholder = true,
}: {
  items?: (CartProductProps | undefined)[];
  isDivided?: boolean;
  isCompact?: boolean;
  isShowPlaceholder?: boolean;
}) => {
  const padding = isCompact ? 'py-1.5' : 'py-4';
  if ((!items || items.length === 0) && isShowPlaceholder) {
    return <CartListStatus variant="empty" />;
  }
  return (
    <>
      <ul className={`flex flex-col gap-y-4 ${padding}`}>
        {items.map((item, index) => (
          <li key={index}>
            <CartProduct {...item} />
          </li>
        ))}
      </ul>

      {isDivided && (
        <div className="mt-4">
          <Divider />
        </div>
      )}
    </>
  );
};
